import { render, staticRenderFns } from "./KollelApplications.vue?vue&type=template&id=27ec48a3&"
import script from "./KollelApplications.vue?vue&type=script&lang=js&"
export * from "./KollelApplications.vue?vue&type=script&lang=js&"
import style0 from "./KollelApplications.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports